import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { TextInputProps, TextInput } from '../../../atoms';
import { InputRow } from '../../../molecules';

interface PaymentInfoHolderNameProps extends TextInputProps {
  error?: string;
}

const PaymentInfoHolderName = ({
  onFocus,
  onBlur,
  value,
  onValueChange,
  error,
  disabled,
}: PaymentInfoHolderNameProps) => {
  const { t } = useTranslation();

  return (
    <InputRow label={t('input.card_name.label')} error={error}>
      <TextInput
        name="holderName"
        value={value}
        disabled={disabled}
        placeholder={t('input.card_name.label') as string}
        onFocus={onFocus}
        onBlur={onBlur}
        onValueChange={onValueChange}
      />
    </InputRow>
  );
};

export default memo(PaymentInfoHolderName);
